module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Kidnapped By the Taliban: A Story of Terror, Hope, and Rescue By Seal Team Six")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct2",
    attrs: {
      "id": "p0011-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#con0",
      "id": "cap0"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "ct3"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#con0"
    }
  }, [_c('b', [_vm._v("KIDNAPPED")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1a",
    attrs: {
      "id": "p0011-02-1"
    }
  }, [_vm._v("10:00 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("A.M")]), _vm._v("., W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EDNESDAY")]), _vm._v(", D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECEMBER")]), _vm._v(" 5, 2012 ")]), _vm._v(" "), _c('p', {
    staticClass: "tx1a"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UL-I-ASSIM")]), _vm._v(", A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FGHANISTAN")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0011-03-2"
    }
  }, [_vm._v("“ARE YOU GETTING ENOUGH PROTEIN IN YOUR DIET? ARE YOU getting enough carbohydrates?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-04-4"
    }
  }, [_vm._v("The questions in Pashto come from Miriam, a local midwife and employee of the same nonprofit I work for. She’s addressing twenty moms and kids jammed into a fifteen-by-twenty-foot office. About half of the visitors sit in metal folding chairs while the others stand. Miriam points with a stick to a board beside her. Tacked to the board are plastic baggies filled with nuts, beans, and rice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0011-05-7"
    }
  }, [_vm._v("Two and a half weeks ago, I was at home with my wife and four children in Colorado Springs, Colorado. Now I am at a medical clinic in Pul-i-assim, a village in eastern Afghanistan. I am the medical director for Morning Star, a non-governmental organization (NGO) committed to helping this nation’s people rebuild their country and their lives. This is my tenth visit to Afghanistan. I’m here to deliver a dose of medical training and hope to people who desperately need both.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_vm._v("What I don’t know is that I will soon be the one in desperate need of help and hope.")])]), _c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-02-2"
    }
  }, [_vm._v("As Miriam speaks, my gaze is drawn to a mother standing near a corner in the back of the room. Her eyes appear locked on the board as she absorbs each word, though I can’t tell for certain because she is covered head to toe in a light-blue burqa, which includes a "), _c('i', [_vm._v("chadri")]), _vm._v(", or veil, to cover her face. She holds an infant no more than two months old in her arms. A toddler stands to the mother’s left, one hand gripped tightly to his mother. He’s coughing repeatedly. On her other side a three-year-old leans against her and wipes her runny nose on her sleeve.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-03-4"
    }
  }, [_vm._v("I wonder about this young mother’s life. I guess that she is nineteen and lives in her husband’s home in a nearby village. I imagine that in addition to caring for her husband and three young children, she takes care of and does all the housework for her extended family—perhaps a mother-in-law and two brothers-in-law. She breastfeeds her younger children but can’t produce enough milk to fully feed them, so her husband is forced to buy low-quality formula during his monthly visit to the closest town, straining an already meager family budget. I have no doubt that this young mother often feels overwhelmed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-04-6"
    }
  }, [_vm._v("She is surely not an educated woman. Most girls in rural Afghanistan are expected to quit school after the second or third grade. Yet I can see that she is highly motivated to care for her family. She leans forward, eager to see the pictures describing good nutrition and hygiene and hear every word of advice.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0012-05-9"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }, [_vm._v("I smile. This is why I am here. It’s hard to describe the sense of fulfillment that wells up in me when I view the clear need in the innocent faces of these young children and the strong desire to improve their health and lives in the attentiveness of their mothers. Medical services ")]), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_vm._v(" in rural Afghanistan are so rare. In moments like these I know my team and I are helping to bridge the gap between what is and what can be. The gap is still wide, but we are making a difference.")])]), _c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-02-2"
    }
  }, [_vm._v("I am glad to finally be back among these people. It’s been a year and a half since my last visit to this clinic. Six previously scheduled trips to the region were canceled due to threats of violence.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-03-4"
    }
  }, [_vm._v("The threat is from the Taliban, the Islamic extremists who use terror and force to impose their strict interpretations of Islamic law. The Taliban ruled Afghanistan from 1996 until December 2001, when they were forced out of power by the U.S.-led invasion that followed the 9/11 attacks on America. Yet the Taliban influence here lives on in an insurgency that claims thousands of lives each year. During the Taliban rule, the villagers in Pul-i-assim fled to Pakistan, returning to their homes only after the regime collapsed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx2t",
    attrs: {
      "id": "p0013-04-7"
    }
  }, [_vm._v("For people living in rural areas where the Taliban influence is strongest, including where we work, the danger is a shadow that never goes away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "p0013-05-9"
    }
  }, [_vm._v("After serving at the clinic all morning, my two native coworkers—Rafiq, a physician and local program director for Morning Star, and Farzad, his assistant—and I enjoy a sumptuous lunch hosted by the local police chief. At two thirty in the afternoon, we drop off the police chief and another local doctor near the medical clinic then begin the four-hour drive back to Kabul.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0013-06-11"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexiii"
    }
  }, [_vm._v("Now, just a few minutes later, we spot a dozen boys walking the same way we’re going on the side of the road. We saw these students in the educational facility next to the medical center this morning. They’re on their way home, after spending time in computer or ")]), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_vm._v(" literacy classes. When we offer them a ride, they pile into the open truck bed, smiling and grateful for the lift. We let them off in a village about five miles down the road, wave good-bye, and continue down the winding dirt road.")])]), _c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-02-2"
    }
  }, [_vm._v("As we drive, I think ahead to my evening plans: dinner and a meeting with my NGO’s country director and his wife in Kabul. We’re going to discuss current programs and plans for the future. There is so much yet to do here. Then, in another week, I will be home with my family and getting ready for Christmas.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-03-4"
    }
  }, [_vm._v("We are traveling in a white, ten-year-old Toyota Hilux. Rafiq is behind the wheel of the four-door pickup for this first leg. I sit beside him in the front seat while Farzad sits in the back.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-04-6"
    }
  }, [_vm._v("When we approach a hairpin right turn about fifty yards ahead, Rafiq slows down. Our road is on a hill that gradually declines. To our left, after a short drop, the mountain rises steeply into sunny blue sky. To our right is an equally steep drop into a canyon below.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-05-9"
    }
  }, [_vm._v("A tap on the shoulder is my first hint that something is wrong—Farzad is reaching forward to get Rafiq’s attention. "), _c('i', [_vm._v("What’s going on?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-06-11"
    }
  }, [_vm._v("Rafiq slams on the brakes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-07-13"
    }
  }, [_vm._v("Through the windshield, a hundred feet ahead of us on the right, I see him. Next to an outcropping, where he’d obviously been hiding moments before, stands a man. He is wearing a thick, beige jacket over traditional garb. On his head is a brown wool "), _c('i', [_vm._v("pakol")]), _vm._v(", a hat with a kind of double-pancake appearance. He has a long black beard that covers his neck.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-08-15"
    }
  }, [_vm._v("What most gets my attention, however, is the ammunition belt around his waist and the Kalashnikov assault rifle in his hands.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0014-09-17"
    }
  }, [_vm._v("The man raises his Kalashnikov—also known as an AK-47—and fires a single shot into the air.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexiv"
    }
  }), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_vm._v("A surreal feeling washes over me. "), _c('i', [_vm._v("No, no")]), _vm._v(", I think. "), _c('i', [_vm._v("Is this staged? This can’t be real.")])])]), _c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-02-2"
    }
  }, [_vm._v("Two more men, also carrying assault rifles, pop out from behind another hill ahead and run directly toward us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-03-4"
    }
  }, [_vm._v("I’m suddenly aware of my heart pumping into overdrive. "), _c('i', [_vm._v("This can’t be happening. Oh, man. I can’t believe this is how my life is going to end. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-04-6"
    }
  }, [_vm._v("One of the pair of men ahead is shouting orders in Pashto. I don’t understand a word. Both Rafiq and Farzad open their doors and get out of the pickup. I follow their lead and do the same. As I open my door, a fourth armed man comes toward us from the rear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-05-8"
    }
  }, [_vm._v("This is clearly a strategic action. Which is it—robbery or kidnapping? I hope the latter. Most roadside robbery victims in these rural areas are quickly killed.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-06-10"
    }
  }, [_vm._v("Rafiq, Farzad, and I huddle together next to the left side of the Hilux. All four of our attackers begin yelling at us. Rafiq and Farzad raise their hands in the air, so I do likewise. The man who arrived from behind us begins to take charge. He appears to be the oldest, perhaps twenty-eight. His beard is shorter and better groomed and his outfit a lighter brown compared to the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-07-12"
    }
  }, [_vm._v("This leader is angry with us. He raises the butt of his rifle as if to strike me with it. I wince, but the blow does not come.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-08-14"
    }
  }, [_vm._v("The leader keeps shouting in Pashto. As Rafiq attempts to answer, the leader flings open the back door of the Hilux and grabs the backpacks Rafiq and I brought. He makes an abrupt search. Rafiq whispers to me, “He wants to know why we’re here and what we do.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0015-09-17"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexv"
    }
  }, [_vm._v("I say nothing and avoid eye contact with the gunmen. Since I am an ethnic Indian, I can easily pass for an Afghan—at least until I open my mouth and those listening realize I don’t speak their language. ")]), _c('a', {
    attrs: {
      "id": "pagexvi"
    }
  }, [_vm._v("I don’t want to incite these men further by revealing that I’m an American.")])]), _c('a', {
    attrs: {
      "id": "pagexvi"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-02-2"
    }
  }, [_vm._v("All our attackers are dressed similarly. The man we spotted first looks to be in his midtwenties and is the tallest of the group, nearly six feet. The other two, who appeared ahead of us, look nearly as old but may be much younger—with their dust-caked faces and ruddy complexions, it’s difficult to tell. The taller of this pair may still be a teen, but he carries himself like an experienced soldier. This one points his rifle at us and gestures for us to step to the side of the road, away from the pickup.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-03-4"
    }
  }, [_c('i', [_vm._v("Now what?")]), _vm._v(" I wonder. "), _c('i', [_vm._v("What are their intentions? Are they going to shoot us right here on the side of the road?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-04-6"
    }
  }, [_vm._v("Suddenly, coming down the same road we’d traveled moments before, a lone man on a motorbike appears. He stops within five hundred feet of us, assesses the situation, and turns around. Seconds after his arrival, he has disappeared. "), _c('i', [_vm._v("Will he report what he’s just seen?")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-05-8"
    }
  }, [_vm._v("One of the gunmen begins tearing a cloth into long strips. He uses one of these strips to tie a blindfold around my head. The makeshift blindfold isn’t 100 percent effective. At the upper left corner I have a tiny opening. Since my hands aren’t tied, I’m able to tug it down a fraction, providing me with a little better view of what’s happening.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-06-10"
    }
  }, [_vm._v("I fear this is the end. My mind is functioning just well enough to offer a silent prayer: "), _c('i', [_vm._v("God, save me from this situation!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-07-12"
    }
  }, [_vm._v("Our captors attempt to put blindfolds on Rafiq and Farzad as well, but something doesn’t work—maybe the other strips are too short. Though it feels like an eternity, it’s probably less than ten minutes later when my blindfold is removed.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0016-08-15"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexvi"
    }
  }, [_vm._v("Now the same strips of cloth are used to tie our hands behind our backs. We’re each pushed into the rear seat of the Hilux. The leader ")]), _c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_vm._v(" climbs into the driver’s seat. The second-oldest joins him in the front passenger seat.")])]), _c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-02-2"
    }
  }, [_vm._v("My heart rate drops one notch.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-03-4"
    }
  }, [_c('i', [_vm._v("Okay. At least this doesn’t appear to be a robbery. We’re still alive. They’re taking us somewhere, so there’s some plan here.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-04-7"
    }
  }, [_vm._v("The leader shifts the Hilux into reverse and guns the engine. He turns us around, driving so quickly and carelessly that for a moment I think we will careen over the road’s edge and tumble down the mountain.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-05-9"
    }
  }, [_vm._v("My heartbeat resumes its frantic pace.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-06-11"
    }
  }, [_vm._v("In a few minutes we reach the village where we’d dropped off the boys. A few of the inhabitants look up as we drive by. I plead with my eyes, "), _c('i', [_vm._v("Please notice that this is a medical truck and there are armed men in the back. Please alert someone!")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-07-13"
    }
  }, [_vm._v("In no time we are through the village and back on the deserted road, heading for the village and medical center, where we had spent the morning.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-08-15"
    }
  }, [_c('i', [_vm._v("This could be good")]), _vm._v(", I think. "), _c('i', [_vm._v("It might all go south when we reach the village and police post, but at least people will know what’s happened to us. ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-08-16"
    }
  }, [_vm._v("But this glimmer of hope vanishes as quickly as it appears. The leader makes an abrupt turn off the road and into a valley. The terrain is rocky, and our captor is driving fast. I’m afraid he’s going either to tip over the Hilux or disable it, leaving us stranded in the middle of nowhere.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-09-18"
    }
  }, [_vm._v("As we bump along, I attempt to slide my hands over to Rafiq’s, thinking I might be able to untie him without being seen. At the same time, I whisper, “Do you have any idea what these guys are thinking?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0017-09-19"
    }
  }, [_vm._v("Almost imperceptibly, he shakes his head. “No, I don’t,” he whispers. “We need to keep quiet.”")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexvii"
    }
  }), _c('a', {
    attrs: {
      "id": "pagexviii"
    }
  }, [_vm._v("I can’t imagine our situation getting any more frightening, but it does. The two kidnappers in front trade angry comments, which I later learn were along the line of, “We will show these donkeys sitting behind their posh desks and computers what real Islamic life is like.” Then the leader tries on a pair of sunglasses he finds in the truck. They apparently don’t fit, so he smashes them against the dashboard.")])]), _c('a', {
    attrs: {
      "id": "pagexviii"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-02-2"
    }
  }, [_vm._v("He isn’t done venting his rage. While holding the steering wheel with his left hand, he rips the rearview mirror from its base with his right. Then he attacks the overhead visor. His number two in the next seat starts doing the same to his visor. Neither is successful at tearing his visor completely off, so each satisfies himself with destroying its shape.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-03-4"
    }
  }, [_vm._v("These guys are out of their minds. They could do anything.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-04-6"
    }
  }, [_vm._v("After fifteen minutes of this wild driving in a wide valley, we enter a passage through hill country that cuts off any view of the surrounding landscape. Then we stop and are ordered out of the Hilux.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-04-7"
    }
  }, [_vm._v("With a jerk of his rifle, the leader points up the mountain on the left. There is no path. I look higher and see more armed men at the top of a hill about two hundred feet above us.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-05-9"
    }
  }, [_vm._v("Apprehension surges up in me like black oil from a well. These aren’t ordinary robbers. This is too systematic.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-06-11"
    }
  }, [_vm._v("I’ve been kidnapped by the Taliban.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-07-13"
    }
  }, [_vm._v("Two of the men grab our backpacks out of the Hilux; then all of us begin climbing. With my hands tied behind me, it’s hard to maintain balance on the steep terrain. I’m sorry to leave the Hilux. It is a last remnant of my work here, of normal life.")])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0018-08-15"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexviii"
    }
  }, [_vm._v("As we walk, I hear our captors talking among themselves. My ")]), _c('a', {
    attrs: {
      "id": "pagexix"
    }
  }, [_vm._v(" sense is that they are talking about us. I fear the worst—that when we reach the top, they will shoot us.")])]), _c('a', {
    attrs: {
      "id": "pagexix"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-02-2"
    }
  }, [_c('i', [_vm._v("God, however this is going to end, please don’t let them torture me to death. Let it be one shot and done.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-03-4"
    }
  }, [_vm._v("It is amazing how quickly everything we take for granted can be ripped away. In the space of a few minutes, I have lost all control of my life. All I can do is take a step, draw a breath, and hope I will be given the chance for another.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-04-6"
    }
  }, [_vm._v("Step.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-05-8"
    }
  }, [_vm._v("Breathe.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0019-06-10"
    }
  }, [_vm._v("Hope.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688f250c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter3.vue
// module id = 72
// module chunks = 0